module.exports = __webpack_public_path__ + "img/ICONE-LIEU.8f88af53.svg";